<script>
    window.location = "/#/docs"
</script>
